<template>
  <b-modal
    id="back-to-home-config-modal"
    ref="modal"
    :title="`VPN Config: ${userName}`"
    size="lg"
    hide-footer
    centered
    @hidden="clear"
  >
    <div
      v-if="isLoading"
      class="d-flex justify-content-center my-3"
    >
      <b-spinner
        variant="primary"
        label="Loading..."
      />
    </div>
    <div v-else-if="config">
      <b-alert
        variant="warning"
        class="mb-2"
        show
      >
        <div class="alert-body">
          This config contains the private key of {{ userName }}. Share it only with this user.
        </div>
      </b-alert>
      <p>
        Scan the QR code with the WireGuard or MikroTik Back To Home app, or import the .conf file.
      </p>
      <div class="d-flex justify-content-center">
        <img
          :src="`data:image/svg+xml;base64,${config.qr_code}`"
          alt="VPN config QR code"
          class="back-to-home-qr-code"
        >
      </div>
      <div class="d-flex flex-wrap justify-content-end mt-2">
        <b-button
          variant="outline-primary"
          class="mr-1 mb-50"
          @click="copyConfig"
        >
          Copy config
        </b-button>
        <b-button
          variant="outline-primary"
          class="mr-1 mb-50"
          @click="downloadQrCode"
        >
          Download QR
        </b-button>
        <b-button
          variant="primary"
          class="mb-50"
          @click="downloadConfig"
        >
          Download .conf
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'
import {
  BModal, BAlert, BButton, BSpinner,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@/libs/clipboard'

export default {
  components: {
    BModal,
    BAlert,
    BButton,
    BSpinner,
  },
  props: {
    siteId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      userName: '',
      config: null,
      isLoading: false,
    }
  },
  methods: {
    ...mapActions('backToHome', ['getUserConfig']),
    async open(user) {
      this.userName = user.name
      this.config = null
      this.isLoading = true
      this.$refs.modal.show()

      try {
        this.config = await this.getUserConfig({ siteId: this.siteId, id: user.id })
      } catch (error) {
        this.$refs.modal.hide()
      } finally {
        this.isLoading = false
      }
    },
    clear() {
      this.config = null
    },
    async copyConfig() {
      // The helper text area must live inside the modal: the modal's focus trap blocks copying from outside it.
      await this.$copyText(this.config.conf, this.$refs.modal.$refs.content)

      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Config copied',
          icon: 'BellIcon',
          variant: 'success',
        },
      })
    },
    downloadConfig() {
      const url = URL.createObjectURL(new Blob([this.config.conf], { type: 'text/plain' }))

      this.download(url, this.config.filename)
      URL.revokeObjectURL(url)
    },
    downloadQrCode() {
      this.download(`data:image/svg+xml;base64,${this.config.qr_code}`, this.config.filename.replace(/\.conf$/, '.svg'))
    },
    download(href, filename) {
      const link = document.createElement('a')
      link.href = href
      link.download = filename
      link.click()
    },
  },
}
</script>

<style lang="scss" scoped>
.back-to-home-qr-code {
  width: 100%;
  max-width: 320px;
}
</style>
